var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"overflow":"hidden","height":"100vh"}},[_c('img',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":require("../assets/404.png"),"alt":""},on:{"click":_vm.logout}})])}
var staticRenderFns = []

export { render, staticRenderFns }